import { Image } from '@starsoft/common/components';
import { TowerBoardCardIconProps } from './props';
import styles from './styles.module.scss';

export default function TowerBoardCardIcon({
  disabled,
  isPlaying,
  row,
  rowsCleared,
  wasClicked,
  wasRevealed,
}: TowerBoardCardIconProps) {
  const baseUrl = `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/tower/ice`;
  const Block = `${baseUrl}/Block.png`;
  const Void = `${baseUrl}/Void.png`;
  const Current = `${baseUrl}/BlockGreen.png`;

  function getBoardIconImage(): string {
    if (!wasRevealed && row == rowsCleared && isPlaying) {
      return Current;
    }

    if (wasRevealed) {
      return Void;
    }

    return Block;
  }

  return (
    <Image
      src={getBoardIconImage()}
      alt="board-icon"
      width={80}
      height={40}
      aria-disabled={disabled}
      className={`${styles.icon} ${disabled ? styles['icon--disabled'] : ''} ${wasRevealed ? !wasClicked : row != rowsCleared ? styles['icon--not-clicked'] : ''}`}
    />
  );
}
